module.exports = __webpack_public_path__ + "static/media/Bitcoin.f26bf61d.png";